function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5 18.343L6.156 24L24.5 5.657L18.843 0L0.5 18.343ZM21.671 5.657L6.157 21.171L3.328 18.342L4.368 17.334L6.49 19.456L7.197 18.749L5.075 16.627L6.489 15.213L7.903 16.627L8.611 15.919L7.197 14.505L8.611 13.091L10.025 14.505L10.732 13.798L9.318 12.384L10.732 10.97L12.854 13.092L13.561 12.384L11.44 10.262L12.854 8.848L14.268 10.262L14.975 9.555L13.561 8.141L14.975 6.727L16.389 8.141L17.096 7.434L15.682 6.02L17.096 4.605L19.217 6.727L19.924 6.02L17.803 3.898L18.842 2.827L21.671 5.657Z",
  fill: "current"
});

var SvgIconmonstrRuler61 = function SvgIconmonstrRuler61(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconmonstrRuler61, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconmonstr-ruler-6 1.f81410d0.svg";
export { ForwardRef as ReactComponent };